import React from 'react';
import { WarmerVisual } from './WarmerVisual';
import type { ProductId } from '../../types/snak';
const INK = '#01332b';
const METAL = '#CBD8D4';
interface ProductVisualProps {
  product: ProductId;
  className?: string;
}

/**
 * Credible, premium rendering of a composite syringe — or the warming device.
 * Personality is carried by the supporting accents, never by the product itself.
 */
export function ProductVisual({
  product,
  className = ''
}: ProductVisualProps) {
  if (product === 'warmer') return <WarmerVisual className={className} data-id="element-222" data-mp="29ttgx0akveya" />;
  const label = product === 'supreme' ? '#0F62AB' : product === 'easyMatch' ? '#6E4A9E' : '#05A63A';
  const wordmark = product === 'supreme' ? 'SUPREME' : product === 'easyMatch' ? 'EASY MATCH' : 'ONE BULK FILL';
  return <svg viewBox="0 0 170 268" className={className} role="img" aria-label={`Filtek ${wordmark.toLowerCase()} composite syringe`} data-id="element-223" data-mp="1vubx6zc52rvs">
      <ellipse cx="85" cy="256" rx="42" ry="6" fill={INK} opacity="0.14" data-id="element-224" data-mp="1qvqvswl5i25r" />

      {/* supporting accents — subtle family-role cues */}
      {product === 'supreme' && <g stroke="#0F62AB" strokeWidth="1.4" opacity="0.6" data-id="element-225" data-mp="1r20qo7wr7x8a">
          <path d="M22 96 h16 M22 116 h10 M22 136 h16 M22 156 h10" strokeLinecap="round" data-id="element-226" data-mp="1d9kkwzcgxl3o" />
          <circle cx="138" cy="120" r="14" fill="none" data-id="element-227" data-mp="1d7rbjcah0mrz" />
          <path d="M138 102 v36 M120 120 h36" strokeLinecap="round" data-id="element-228" data-mp="1hbz3rjg50kuy" />
        </g>}
      {product === 'easyMatch' && <g data-id="element-229" data-mp="24ynoecwj6rf9">
          <circle cx="28" cy="104" r="9" fill="#EBD9BE" data-id="element-230" data-mp="24yxgq751tao4" />
          <circle cx="28" cy="126" r="9" fill="#E0C9A6" data-id="element-231" data-mp="29yjuchosgsxg" />
          <circle cx="28" cy="148" r="9" fill="#D3B88E" data-id="element-232" data-mp="1w0bzqgf863pg" />
          <path d="M140 100 q12 26 0 52" fill="none" stroke="#6E4A9E" strokeWidth="1.6" strokeDasharray="4 5" strokeLinecap="round" data-id="element-233" data-mp="1vzsil1xefjch" />
        </g>}
      {product === 'oneBulkFill' && <g stroke="#05A63A" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-234" data-mp="pl18c7mdym5s">
          <path d="M26 100 l10 10 -10 10" data-id="element-235" data-mp="2r9p4jtqrmvuf" />
          <path d="M26 124 l10 10 -10 10" data-id="element-236" data-mp="2r8dxnl20x7z3" />
          <path d="M140 98 v56" strokeWidth="1.4" data-id="element-237" data-mp="2maccmul1eykz" />
          <path d="M134 98 h12 M134 154 h12" strokeWidth="1.4" data-id="element-238" data-mp="2maukkoh2b18q" />
        </g>}

      {/* nozzle */}
      <path d="M78 12 h14 l3 22 h-20 z" fill={METAL} data-id="element-239" data-mp="2hhjdqnc92kgt" />
      <rect x="68" y="32" width="34" height="11" rx="5" fill={label} data-id="element-240" data-mp="2dik9z6298tqy" />

      {/* barrel */}
      <rect x="62" y="42" width="46" height="152" rx="16" fill="#FFFFFF" stroke={INK} strokeWidth="2.2" data-id="element-241" data-mp="28j7ddtll08b6" />
      <rect x="62" y="80" width="46" height="74" fill={label} data-id="element-242" data-mp="1yki5mtneg48n" />
      <rect x="70" y="58" width="12" height="14" rx="6" fill={INK} opacity="0.08" data-id="element-243" data-mp="1yl05s1d6n2lu" />

      <text transform="rotate(-90 85 117)" x="85" y="117" textAnchor="middle" fill="#FFFFFF" fontFamily="Inter, sans-serif" fontSize="13" fontWeight="600" letterSpacing="1.5" data-id="element-244" data-mp="1uk7xbac4x1qm">
        FILTEK
      </text>
      <text transform="rotate(-90 100 117)" x="100" y="117" textAnchor="middle" fill="#FFFFFF" fontFamily="Inter, sans-serif" fontSize="6.5" letterSpacing="1.6" opacity="0.9" data-id="element-245" data-mp="1apy5vfyij5ik">
        {wordmark}
      </text>

      {/* plunger */}
      <rect x="52" y="194" width="66" height="9" rx="4.5" fill={INK} data-id="element-246" data-mp="1of9sml0ochcg" />
      <rect x="77" y="203" width="16" height="32" rx="7" fill={METAL} data-id="element-247" data-mp="rqu1ikhx1zx8" />
      <rect x="62" y="233" width="46" height="11" rx="5.5" fill={INK} data-id="element-248" data-mp="rsnc2avnh4ai" />
    </svg>;
}